import { BaseEntryScope } from '#packages/apilib';
import { EditorAPIKey, EditorCoreApiKey } from '#packages/apis';
import type { __EditorAPI as EditorAPI } from '#packages/rEditor';
import { PromoteStore } from './store';

type EditorCoreApi = ReturnType<
  (typeof import('../editorCore/api'))['createEditorCoreApi']
>;

export class PromoteScope extends BaseEntryScope {
  editorAPI = this.useDependency<EditorAPI>(EditorAPIKey);
  editorCoreAPI = this.useDependency<EditorCoreApi>(EditorCoreApiKey);
  store = this.declareStore(PromoteStore);
}
